import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledTag {
  theme: any;
}

export const StyledTag = styled.div<IStyledTag>`
  .body {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
  }
  .main {
    flex: 0 1 auto;
  }
  .main-header {
    padding: ${rem(`16px`)} ${rem(`16px`)} 0;
  }
  .mobile-newsletter,
  .main-body {
    ${({ theme }) => theme.breakpoints.phablet`
      padding: ${rem(`16px`)} ${rem(`16px`)} 0;
    `}
  }
  && .heading .content {
    padding-top: ${rem(60)};
  }
  .spacer {
    flex: 1 0 24px;
  }
  .aside {
    flex: 1 0 350px;
    max-width: 350px;
  }
  .cta {
    margin-bottom: ${rem(`24px`)};
  }
  .content {
    display: grid;
    grid-template-columns: repeat(1, auto);
    grid-template-rows: 1fr;
    gap: ${rem(`12px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      gap: ${rem(`24px`)};
    `}
  }
  .tag-title {
    display: flex;
    align-items: center;

    &__name {
      font-size: ${rem(`36px`)};
      margin: 0;
      margin-right: ${rem(`12px`)};
      ${({ theme }) => theme.breakpoints.phablet`
        font-size: ${rem(`24px`)};
      `}
    }
  }
  .grid-view {
    display: grid;
    overflow: hidden;
    gap: ${rem(`18px`)};
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: 1fr;
    ${({ theme }) => theme.breakpoints.phablet`
      gap: ${rem(`20px`)};
      grid-template-columns: repeat(2, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      gap: ${rem(`24px`)};
      grid-template-columns: repeat(3, 1fr);
    `}
  }
  .post-card--hero {
    max-width: 100%;
    ${({ theme }) => theme.breakpoints.tablet`
      max-width: 66%;
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      max-width: 100%;
    `}
  }
`;
